import WhatsAppLogo from '../Icons/WhatsAppLogo';
import { useTranslation } from '../../hook/translations';

import styles from './index.module.scss';

function ContactUsWhatsAppButton() {
    const { t } = useTranslation('common');
    return (
        <span className={styles.container}>
            <span>{t('Contact Restaurant')}</span>
            <WhatsAppLogo width={30} height={30} />
        </span>
    );
}

export default ContactUsWhatsAppButton;
